import React, { FunctionComponent, useRef, useContext } from "react";

// MUI
import { useTheme } from "@mui/material";
import Box from '@mui/material/Box';

// Custom
import SidebarContext, { SidebarContextType, PositionType } from './SidebarContext/SidebarContext';


const SidebarContent: FunctionComponent<any> = (props) => {
  const sidebarContext = useContext(SidebarContext) as SidebarContextType;

  const contentRef = useRef<HTMLDivElement | null>(null);

  const theme = useTheme();

  const { children } = props;

  const element = document.createElement("div");
  element.className = "sidebar-content";

  contentRef.current = element;

  const isCollapsed = sidebarContext.collapsed;
  const isLeft = sidebarContext.position === "left";
  const isRight = sidebarContext.position === "right";

  return (
    <Box m={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        top: 0,
        right: isRight ? 40 : isLeft ? 0 : undefined,
        bottom: 0,
        left: isLeft ? 40 : isRight ? 0 : undefined,
        overflowX: "hidden",
        overflowY: "hidden",
        bgcolor: "background.default"
      }}
    >
      {children}
    </Box>
  );
};

export default SidebarContent;
